import misRutas from 'vue-routes-generator'
import MainComponent from './Main'
import Tablero from './components/tablero'
// import OverView from './components/overview/mainOverview.component'

export default {
	install: Vue => {
		misRutas.route('/main').child('solicitudes', {
			name: 'Solicitudes',
			component: MainComponent
		})

		misRutas.route('/main').child('solicitudes').child('', {
			name: 'Tablero',
			component: Tablero
		})

		misRutas.route('/main').child('solicitudes').child('solicitud/:SolicitudID', {
			name: 'Solicitud',
			component: Tablero
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/solicitudes/vue/index.js